import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SearchSchema } from './-constants';
import { getDevicePeopleCount } from './-query/api';

export const Route = createFileRoute('/_staff/devices/_list/people/')({
  validateSearch: zodValidator(SearchSchema),
  loader: getDevicePeopleCount,
});
